import { request } from './http';

export async function getFormTypes() {
    return request('/form-types');
  }

export async function getFormTypeRaciProfile(formTypeId) {
    return request(`/form-types/${formTypeId}/raci-profile`);
  }

export async function getFormStatusesByFacility(facilityId) {
    const qp = new URLSearchParams({ facilityId: String(facilityId) });
    return request(`/form-status?${qp.toString()}`);
  }

export async function getAllFormStatuses() {
    // Call without facilityId parameter to get all form statuses
    return request('/form-status');
  }

export async function getFormStatusById(id) {
    return request(`/form-status/${id}`);
  }

export async function createFormStatus(statusData) {
    return request('/form-status', {
      method: 'POST',
      body: JSON.stringify(statusData)
    });
  }

export async function updateFormStatus(id, statusData) {
    return request(`/form-status/${id}`, {
      method: 'PUT',
      body: JSON.stringify(statusData)
    });
  }

export async function deleteFormStatus(id) {
    return request(`/form-status/${id}`, { method: 'DELETE' });
  }

export async function getRaciAssignmentsForFormStatus(id) {
    return request(`/form-status/${id}/raci-assignments`);
  }

export async function getNewestRecordForFormStatus(id) {
    return request(`/form-status/${id}/newest-record`);
  }

export async function getPwsApprovalParameters() {
    return request('/pws-approval-parameters');
  }

export async function getPwsApprovalParameterFormTypes() {
    return request('/pws-approval-parameters/form-types');
  }

export async function createPwsApprovalParameters(payload) {
    return request('/pws-approval-parameters', {
      method: 'POST',
      body: JSON.stringify(payload)
    });
  }

export async function updatePwsApprovalParameters(id, payload) {
    return request(`/pws-approval-parameters/${id}`, {
      method: 'PUT',
      body: JSON.stringify(payload)
    });
  }

export async function deletePwsApprovalParameters(id) {
    return request(`/pws-approval-parameters/${id}`, {
      method: 'DELETE'
    });
  }

export async function setRaciAssignmentsForFormStatus(id, assignments) {
    return request(`/form-status/${id}`, {
      method: 'PUT',
      body: JSON.stringify(assignments),
    });
  }

export const formsStatusesApi = {
  getFormTypes,
  getFormTypeRaciProfile,
  getFormStatusesByFacility,
  getAllFormStatuses,
  getFormStatusById,
  createFormStatus,
  updateFormStatus,
  deleteFormStatus,
  getRaciAssignmentsForFormStatus,
  getNewestRecordForFormStatus,
  getPwsApprovalParameters,
  getPwsApprovalParameterFormTypes,
  createPwsApprovalParameters,
  updatePwsApprovalParameters,
  deletePwsApprovalParameters,
  setRaciAssignmentsForFormStatus,
};

